module.exports = "https://trybtryb-legacy.web.app/img/designed-by-charlotte.a09bd523.webp";